import { render, staticRenderFns } from "./classifySearch.vue?vue&type=template&id=47a1cdc6&scoped=true"
import script from "./classifySearch.vue?vue&type=script&lang=js"
export * from "./classifySearch.vue?vue&type=script&lang=js"
import style0 from "./classifySearch.vue?vue&type=style&index=0&id=47a1cdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a1cdc6",
  null
  
)

export default component.exports